// React import not needed with React 19+ JSX transform
import { ScoreSlider } from "@/components/ui/score-slider";
import type { FieldConfig } from "../types";

interface ScoreSliderFieldProps<T> {
  field: FieldConfig<T>;
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  onBlur: () => void;
  disabled?: boolean;
  id: string;
  placeholder?: string;
  "aria-describedby"?: string;
}

export function ScoreSliderField<T>({
  field,
  value,
  onChange,
  onBlur,
  disabled,
  id,
  "aria-describedby": ariaDescribedBy,
}: ScoreSliderFieldProps<T>) {
  // Extract slider-specific configuration from field if available
  const min = field.min ?? 0;
  const max = field.max ?? 100;
  const step = field.step ?? 1;
  const showValue = field.showValue ?? true;

  return (
    <ScoreSlider
      id={id}
      value={value ?? 0}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled || field.disabled}
      min={min}
      max={max}
      step={step}
      showValue={showValue}
      aria-describedby={ariaDescribedBy}
      aria-label={field.label}
    />
  );
}